import { ConfigurationChangeModel, LockModel, RootState, StoreConstants, ConfigurationChangeState } from '@/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ConfigurationChangeState, RootState> = {
  [StoreConstants.ConfigurationChange.Getters.ConfigurationChange](state): ConfigurationChangeModel {
    return state.configurationChange;
  },
  [StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock](state): LockModel | null {
    return state.configurationChange.lock;
  },
  [StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock](state): boolean {
    return state.configurationChange.bypassLockingOnToolkit;
  },
  [StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession](state): boolean {
    return state.configurationChange.lock?.isLockedByCurrentSessionId ?? false;
  },
  [StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading](state): boolean {
    return state.isLoading;
  }
};
